import React, { useState, useEffect } from "react";
import { FileText, FolderOpen, Users, Plus, Eye } from "lucide-react";
import { fetchStats } from "@/hooks/useStats";
import { motion } from "framer-motion";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { useToast } from "@/hooks/use-toast";

const DashboardCards = () => {
  const [stats, setStats] = useState([]);
  const { toast } = useToast();
  // Icons in the order matching BE data
  const iconMap = [FolderOpen, FileText, Eye, Users];

  const getStats = async () => {
    try {
      const res = await fetchStats();
      setStats(res.dashboard || res);
    } catch (err) {
      toast({
        title: "Error",
        description: err.response?.data?.message || "Failed to load Stats.",
        variant: "destructive",
      });
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => {
        const Icon = iconMap[index]; // 👈 pick the right icon
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.3 }}
            whileHover={{ scale: 1.02 }}
          >
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-muted-foreground">
                      {stat.title}
                    </p>
                    <p className="text-3xl font-bold">{stat.value}</p>
                    <p className="text-xs text-green-600 mt-1">{stat.change}</p>
                  </div>
                  <Icon className={`h-8 w-8 ${stat.color}`} />
                </div>
              </CardContent>
            </Card>
          </motion.div>
        );
      })}
    </div>
  );
};

export default DashboardCards;
